import React from 'react';
import './LandingPageDevelopment.css';
import { Helmet } from "react-helmet-async";
const features = [
    "One-Page High-Impact Design",
    "Clear CTA (Call-To-Action) Placement",
    "Lead Capture Forms & CRM Integration",
    "A/B Testing Ready Layouts",
    "Fast Loading & Mobile Responsive",
    "SEO-Optimized Structure",
    "Conversion Tracking Integration",
    "Custom Domain & Hosting Support"
];

const benefits = [
    "Boost Lead Generation",
    "Increase Ad Campaign ROI",
    "Targeted Audience Engagement",
    "Fewer Distractions, More Conversions",
    "Perfect for Product Launches",
    "Quick to Build & Launch",
    "Focused Messaging",
    "Improved User Experience"
];

const useCases = [
    "Product Launch Campaigns",
    "Paid Ad Promotions (Google/Facebook)",
    "Event or Webinar Registrations",
    "App Downloads",
    "Consultation or Demo Requests",
    "Newsletter Subscriptions",
    "Giveaway or Contest Pages",
    "Waitlists or Coming Soon Pages"
];

const LandingPageDevelopment = () => {
    return (
        <div className="landing-container">
            <Helmet>
  <title>Landing Page Development | APTech Solution</title>
  <meta 
    name="description" 
    content="Boost your business with APTech Solution. Get free consultation for web development, mobile apps, Salesforce, software solutions, and digital marketing." 
  />
</Helmet>

            <h1 className="landing-title">Landing Page Development</h1>
            <p className="landing-subtitle">
                High-converting, fast-loading landing pages designed to maximize user action and ROI for your marketing goals.
            </p>

            <section className="landing-section">
                <h2 className="section-heading">What is a Landing Page?</h2>
                <p className="landing-paragraph">
                    A landing page is a standalone web page designed with a single focus — to drive a specific action such as signups, downloads, or purchases. It’s built to convert visitors into leads or customers.
                </p>
            </section>

            <section className="landing-section">
                <h2 className="section-heading">Key Features</h2>
                <div className="card-grid">
                    {features.map((feature, idx) => (
                        <div className="feature-card" key={idx}>
                            <span className="card-icon">📌</span>
                            <p>{feature}</p>
                        </div>
                    ))}
                </div>
            </section>

            <section className="landing-section">
                <h2 className="section-heading">Who Needs a Landing Page?</h2>
                <div className="card-grid">
                    {useCases.map((item, idx) => (
                        <div className="feature-card" key={idx}>
                            <span className="card-icon">🎯</span>
                            <p>{item}</p>
                        </div>
                    ))}
                </div>
            </section>

            <section className="landing-section">
                <h2 className="section-heading">Why Landing Pages Work</h2>
                <div className="card-grid">
                    {benefits.map((benefit, idx) => (
                        <div className="feature-card" key={idx}>
                            <span className="card-icon">🚀</span>
                            <p>{benefit}</p>
                        </div>
                    ))}
                </div>
            </section>

            <section className="cta-box">
                <h3>Want More Leads or Sales?</h3>
                <p>Let us design a focused, high-performing landing page that turns visitors into results.</p>
                <a href="https://wa.me/919316580274" target="_blank" rel="noopener noreferrer">
                    <button className="cta-button">Start My Landing Page</button>
                </a>
               
            </section>
        </div>
    );
};

export default LandingPageDevelopment;
